<template>
  <div class="about_box">
    <img src="@/assets/logo_hx.png" class="logo_hx" alt="" />
    <h2>易经对戒配色选项表</h2>
    <h3>I-Ching Pair Rings Color Options Table</h3>
    <!-- PC端：表格 -->
     <div class="pc-table" v-if="!isMobile">
        <el-table :data="tableData" style="width: 100%" border >
          <el-table-column prop="position" label="位置" width="120" align="center" fixed>
          </el-table-column>
          <el-table-column
            prop="zuanshiImg"
            label="钻石颜色"
            v-if="type == 1"
            align="center"
          >
            <template slot-scope="scope">
              <img :src="getImgSrc(scope.row.zuanshiImg)" alt="" />
            </template>
          </el-table-column>
          <el-table-column
            prop="zuanshicolor"
            label="钻石颜色名称"
            width="140"
            v-if="type == 1"
            align="center"
          >
          </el-table-column>
          <el-table-column label="金属颜色-阳" align="center">
            <template slot-scope>
              <img src="@/assets/yang.png" alt="" />
            </template>
          </el-table-column>

          <el-table-column label="金属颜色-阴"  align="center">
            <template slot-scope>
              <img src="@/assets/yin.png" alt="" />
            </template>
          </el-table-column>
          <el-table-column prop="jinshuColor" label="金属颜色名称" width="140" align="center">
          </el-table-column>
        </el-table>
      </div>

    <!-- 移动端：列表 -->
    <div class="mobile-list" v-else>
      <div class="list-item" v-for="(item, index) in tableData" :key="index">
        <div class="item-left">
          <div class="item-image">
            <!-- type==1时显示3张图：钻石、阳、阴 -->
            <template v-if="type == 1 && item.zuanshiImg">
              <img src="@/assets/yang.png" alt="" class="yang-img" />
              <img src="@/assets/yin.png" alt="" class="yin-img" />
              <img :src="getImgSrc(item.zuanshiImg)" alt="" class="zuanshi-img" />
            </template>
            <!-- type==2时显示2张图：阳、阴 -->
            <template v-else>
              <img src="@/assets/yang.png" alt="" class="yang-img" />
              <img src="@/assets/yin.png" alt="" class="yin-img" />
            </template>
          </div>
        </div>
        <div class="item-right">
          <div class="item-title">{{ item.position }}</div>
          <div class="item-content">
            <div v-if="type == 1 && item.zuanshicolor" class="item-row">
              <span class="label">钻石颜色：</span>
              <span class="value">{{ item.zuanshicolor }}</span>
            </div>
            <div class="item-row">
              <span class="label">金属颜色：</span>
              <span class="value">{{ item.jinshuColor }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btm_view">
      <el-button type="primary" @click="backHome">上一步</el-button>
      <el-button type="primary" @click="backToServe">确定</el-button>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import {
  deleteOrganizationCode,
  getExampleData,
} from "@/services/apiMethods.js";
export default {
  data() {
    return {
      type: 1, //1为带钻石，2为不带钻石
      isMobile: window.innerWidth <= 768,
      tableData: [
        {
          position: "位置一",
          zuanshiImg: "z_fenzuan.png",
          zuanshicolor: "粉钻",
          jinshuColor: "白金",
        },
        {
          position: "位置二",
          zuanshiImg: "z_huangzuan.png",
          zuanshicolor: "黄钻",
          jinshuColor: "黄金",
        },
        {
          position: "位置三",
          zuanshiImg: "z_lanzuan.png",
          zuanshicolor: "蓝钻",
          jinshuColor: "玫瑰金",
        },
      ],
      resultData: {
        data: "",
        num: 0,
      },
    };
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    },
    getImgSrc(fileName) {
      return require(`@/assets/${fileName}`);
    },
    backHome() {
      const diamondId = localStorage.getItem("diamondId") || "";
      const userId = localStorage.getItem("userId") || "";
      router.push({
        path: "/",
        query: {
          diamondId: diamondId,
          userId: userId,
        },
      });
    },
    async backToServe() {
      // 先调用 payServe 接口
      await this.payServe();
      window.parent.postMessage({ msg: 'closeDiyPopup' }, '*');
     
      // 然后调用删除接口
      let res = await deleteOrganizationCode(this.resultData.data);
      console.log(res, "res");
      if (res) {
        // this.backHome();
      }
    },
    async payServe() {
      const diamondId = localStorage.getItem("diamondId") || "";
      const userId = localStorage.getItem("userId") || "";
      const type = localStorage.getItem("type");
      const isHaveZuanshi = type == 1;
      const selectData = JSON.parse(localStorage.getItem("selectData") || "[]");
      const wuzuanSelectData = JSON.parse(
        localStorage.getItem("wuzuanSelectData") || "[]"
      );

      const response = await getExampleData({
        materialType: isHaveZuanshi ? "diamonds" : "metals",
        resultDtoList: isHaveZuanshi ? selectData : wuzuanSelectData,
        diamondId: diamondId,
        userId: userId,
      });
      console.log(response, "-----------");
      if (response.code == 0) {
        this.resultData = response.data;
        this.$message.success("提交成功");
      } else {
        this.resultData = {};
      }
      localStorage.setItem("resultData", JSON.stringify(this.resultData));
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.type = localStorage.getItem("type");
    const resultDataStr = localStorage.getItem("resultData");
    this.resultData = resultDataStr
      ? JSON.parse(resultDataStr)
      : { data: "", num: 0 };
    if (this.type == 1) {
      this.tableData = JSON.parse(localStorage.getItem("selectData") || "[]");
    } else {
      this.tableData = JSON.parse(
        localStorage.getItem("wuzuanSelectData") || "[]"
      );
    }
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped lang="scss">
.about_box {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 0.5rem;
  box-sizing: border-box;

  h2,
  h3 {
    font-weight: 500;
    margin: 0.3rem 0;
    color: #333;
  }

  h2 {
    font-size: 1.2rem;
  }

  h3 {
    font-size: 0.9rem;
    color: #666;
  }

  .logo_hx {
    display: block;
    margin: 0.5rem auto 0.5rem;
    height: 40px;
    z-index: 10;
    transform: scale(5);
    transform-origin: center;
  }

  > h2,
  > h3 {
    text-align: center;
    flex-shrink: 0;
  }

  // PC端：表格样式
  ::v-deep .pc-table {
    flex: 1;
    overflow: auto;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    margin: 0.5rem auto;
    max-width: 1200px;
    width: 95%;
    min-height: 0; // 确保flex子元素可以缩小

    // 表格内部不滚动，让外层容器滚动
    .el-table__header-wrapper,
    .el-table__body-wrapper {
      overflow: visible !important;
    }

    th {
      background-color: #f5f7fa;
      color: #333;
      font-weight: 600;
      padding: 0.5rem;
      font-size: 0.85rem;
    }

    td {
      padding: 0.4rem;
      font-size: 0.8rem;
    }

    img {
      width: 60px;
      height: 60px;
      object-fit: contain;
    transform: scale(2);
    transform-origin: center;
    }
  }

  // 移动端：列表样式
  .mobile-list {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    margin: 0.5rem 0;
    padding: 0.5rem;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */

    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera */
    }

    .list-item {
      display: flex;
      align-items: center;
      padding: 0.8rem;
      margin-bottom: 0.8rem;
      background: #fff;
      border-radius: 8px;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
      border: 1px solid #f0f0f0;

      &:last-child {
        margin-bottom: 0;
      }

        .item-left {
          flex-shrink: 0;
          width: 120px;
          margin-right: 1rem;

          .item-image {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.3rem;
            flex-wrap: wrap;

            img {
              width: 50px;
              height: 50px;
              object-fit: contain;
            }

            .zuanshi-img {
              width: 60px;
              height: 60px;
            }

            .yang-img,
            .yin-img {
              width: 45px;
              height: 45px;
            }
          }
        }

      .item-right {
        flex: 1;
        min-width: 0;

        .item-title {
          font-size: 0.9rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 0.5rem;
        }

        .item-content {
          .item-row {
            display: flex;
            align-items: center;
            margin-bottom: 0.3rem;
            font-size: 0.8rem;

            &:last-child {
              margin-bottom: 0;
            }

            .label {
              color: #666;
              margin-right: 0.3rem;
              white-space: nowrap;
            }

            .value {
              color: #333;
              font-weight: 500;
            }
          }
        }
      }
    }
  }

  .btm_view {
    flex-shrink: 0;
    padding: 0.5rem;
    display: flex;
    justify-content: center;
    gap: 1rem;
    background: rgba(255, 255, 255, 0.95);
    border-radius: 8px;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 0.5rem;

    ::v-deep .el-button {
      padding: 0.6rem 1.5rem;
      font-size: 0.9rem;
      border-radius: 6px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  // 移动端优化
  @media (max-width: 768px) {
    padding: 0.3rem;
    background: #ffffff;
    overflow-x: hidden;
    overflow-y: hidden; // 确保整体页面没有滚动条

    h2 {
      font-size: 1rem;
    }

    h3 {
      font-size: 0.75rem;
    }

    .mobile-list {
      .list-item {
        padding: 0.7rem;

        .item-left {
          width: 110px;
          margin-right: 0.8rem;

          .item-image {
            img {
              width: 45px;
              height: 45px;
              transform: scale(3);
              transform-origin: center;
            }

            .zuanshi-img {
              width: 55px;
              height: 55px;
              transform: scale(3);
              transform-origin: center;
            }

            .yang-img,
            .yin-img {
              width: 40px;
              height: 40px;
              transform: scale(2);
              transform-origin: center;
            }
          }
        }

        .item-right {
          .item-title {
            font-size: 0.85rem;
            margin-bottom: 0.4rem;
          }

          .item-content {
            .item-row {
              font-size: 0.75rem;
              margin-bottom: 0.25rem;
            }
          }
        }
      }
    }

    .btm_view {
      padding: 0.4rem;
      gap: 0.8rem;
      flex-wrap: wrap;
      background: #ffffff;

      ::v-deep .el-button {
        padding: 0.5rem 1.2rem;
        font-size: 0.8rem;
        flex: 1;
        min-width: 100px;
      }
    }
  }

  // 小屏幕手机优化
  @media (max-width: 480px) {
    h2 {
      font-size: 0.9rem;
    }

    h3 {
      font-size: 0.65rem;
    }

    .mobile-list {
      .list-item {
        padding: 0.6rem;

        .item-left {
          width: 100px;
          margin-right: 0.6rem;

          .item-image {
            img {
              width: 40px;
              height: 40px;
              transform: scale(3);
              transform-origin: center;
            }

            .zuanshi-img {
              width: 50px;
              height: 50px;
              transform: scale(3);
              transform-origin: center;
            }

            .yang-img,
            .yin-img {
              width: 35px;
              height: 35px;
              transform: scale(2);
              transform-origin: center;
            }
          }
        }

        .item-right {
          .item-title {
            font-size: 0.8rem;
          }

          .item-content {
            .item-row {
              font-size: 0.7rem;
            }
          }
        }
      }
    }

    .btm_view {
      ::v-deep .el-button {
        padding: 0.4rem 1rem;
        font-size: 0.75rem;
      }
    }
  }
}
</style>
